const toError = (err: any) => {
    return err.error?.message || err.error?.error || err.error?.toString() || (err.toString ? err.toString() : err);
}

export { toError };
